import React, { Component } from 'react'
import { List } from "utils/ui";
import UserStore from '../stores/UserStore';
export default class ViewNotes extends Component {
    render() {
        const theme = UserStore.theme();
        const listItems = this.props.notes.map((note, key) =>
            <div style={{ fontSize: "15px", color: theme.darkBackground || "#1f2937", lineHeight: 1.5 }}>
                {note}
            </div>);
        return (
            <div className="NoteFont" style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '10px' }}>
                <List
                    size="large"
                    header={<div style={{ fontSize: "1.25rem", color: theme.darkBackground || "#1f2937", fontWeight: 700, letterSpacing: "0.02em" }}>Notes</div>}
                    style={{
                        background: "rgba(255, 255, 255, 0.78)",
                        borderRadius: "14px",
                        border: `1px solid ${theme.darkBackground || "#d1d5db"}`,
                        boxShadow: "0 10px 22px rgba(15, 23, 42, 0.10)",
                        overflow: "hidden"
                    }}
                    bordered
                    dataSource={listItems}
                    renderItem={item => (
                        <List.Item style={{
                            padding: "12px 14px",
                            borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
                            background: "rgba(255,255,255,0.45)"
                        }}>
                            {item}
                        </List.Item>
                    )}
                />
            </div>
        )
    }
}
